import React, { Component } from 'react';
import { HashRouter as Router, Route } from "react-router-dom";

import Cart from './Cart';
import Checkout from './Checkout';
import Processing from './Processing';
import Summary from './Summary';

class App extends Component {

    render() {
        return (
            <Router>
                <Route path="/" exact component={Cart} />
                <Route path="/checkout" exact component={Checkout} />
                <Route path="/summary" exact component={Summary} />
                <Route path="/processing" exact component={Processing} />
            </Router>
        );
    }
}

export default App;
